import { ACTIONS_OPERATOR } from '../_constants/operator.constants';

const initialState = {
  byId: {},
};

// NOTE: Operator structure currently has a number of child entities. These
//       be flattened: machineNames, machineIDS
export function operatorReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_OPERATOR.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_OPERATOR.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_OPERATOR.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default operatorReducer;
